<template>

  <tr
    @click="$router.push({path: '/requisition/' + requisition._id})"
    class="table-tr-pointer">
    <td class="text-truncate">
      <span
        @click="$event.stopPropagation()">
        <router-link
          style="color: inherit;"
          :to="{path: '/requisition/' + requisition._id }">
          {{ requisition.title }}
          <span class="subtext">#{{ requisition.code }}</span>
          </router-link>
        <span v-if="requisition.status === 'archived'">- <span class="badge badge-light">{{ $t('Archived') }}</span></span>
      </span>
    </td>
    <td class="text-truncate">
      <div v-if="requisition.approvalflow">
        <span
          class="badge"
          :class="approvalflowStatus.style">{{ approvalflowStatus.name }}</span>
        <span
          v-if="requisition.approvalflow.status === 'pending' && requisition.approvalflow.total_groups">{{ requisition.approvalflow.current_group }}/{{ requisition.approvalflow.total_groups }} {{ requisition.approvalflow.current_group_start_at | moment('fromNow', $i18n.locale) }}</span>
      </div>
    </td>
    <td class="text-truncate">{{ requisition.openings }}</td>
    <td class="text-truncate">{{ requisition.hiring_manager_name }}</td>
    <td class="text-truncate"><span v-if="requisition.departament_id">{{ requisition.departament_id.name }}</span></td>
    <td class="text-truncate"><span v-if="requisition.company_id">{{ requisition.company_id.name }}</span></td>
    <td class="text-truncate">
      <div @click="$event.stopPropagation()">
        <router-link
        v-if="requisition.job"
        :to="{path: '/job/' + requisition.job._id }">
        Acessar
        </router-link>
      </div>
    </td>
    <td class="text-truncate">{{ $d(new Date(requisition.created_at), 'short') }}</td>
    <td class="text-truncate">
      <RelatedUser
        :master="requisition.owner_user_id"
        :users="[]"
        style="margin: -5px 0;">
        </RelatedUser>
    </td>
  </tr>

</template>

<script>
import RelatedUser from '@/components/Parts/RelatedUser'

export default {
  name: 'RequisitionListItem',
  components: {
    RelatedUser
  },
  props: {
    requisition: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  computed: {
    approvalflowStatus () {
      const map = {
        pending: {
          name: this.$t('Pending'),
          style: 'badge-warning'
        },
        stoped: {
          name: this.$t('Stopped'),
          style: 'badge-secondary'
        },
        approved: {
          name: this.$t('Approved'),
          style: 'badge-success'
        },
        disapproved: {
          name: this.$t('Disapproved'),
          style: 'badge-danger'
        }
      }

      if (this.requisition.approvalflow) {
        const status = this.requisition.approvalflow.status
        return map[status]
      } else {
        return null
      }
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/RequisitionList/RequisitionListItem.vue